export const getServerURL = () => {
  // Returns the backend server URL, always with a slash at the end
  let url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL || '';
  if (!url.endsWith('/')) {
    url += '/';
  }
  return url;
};

export const getBusinessEmailServiceURL = (businessType, businessId) =>
  `${getServerURL()}businesses/${businessType}s/${businessId}/email/`;

export const cleanDomainName = potentialDomain => {
  const sideHyphensRegex = /(^-+|-+$)/g;
  const consecutiveHyphens = /-+/g;
  const invalidChars = /[^a-z0-9-]/g;
  return potentialDomain
    .split('.')
    .map(s =>
      s
        .replaceAll(sideHyphensRegex, '')
        .replaceAll(consecutiveHyphens, '-')
        .replaceAll(invalidChars, ''),
    )
    .join('.');
};
